export interface IExternalServiceLog {
  externalServiceLogId: string;
  service: string;
  direction: string;
  method: string;
  url: string;
  statusCode: number | null;
  error: string | null;
  movementId: string | null;
  neighborhoodId: string | null;
  createdAt: string;
  requestHeaders?: string;
  requestBody?: string;
  responseHeaders?: string | null;
  responseBody?: string | null;
}

export class ExternalServiceLog {
  externalServiceLogId: string;
  service: string;
  direction: string;
  method: string;
  url: string;
  statusCode: number | null;
  error: string | null;
  movementId: string | null;
  neighborhoodId: string | null;
  createdAt: string;
  requestHeaders?: string;
  requestBody?: string;
  responseHeaders?: string | null;
  responseBody?: string | null;

  constructor(data: IExternalServiceLog) {
    this.externalServiceLogId = data.externalServiceLogId;
    this.service = data.service;
    this.direction = data.direction;
    this.method = data.method;
    this.url = data.url;
    this.statusCode = data.statusCode;
    this.error = data.error;
    this.movementId = data.movementId;
    this.neighborhoodId = data.neighborhoodId;
    this.createdAt = data.createdAt;
    this.requestHeaders = data.requestHeaders;
    this.requestBody = data.requestBody;
    this.responseHeaders = data.responseHeaders;
    this.responseBody = data.responseBody;
  }

  get directionLabel(): string {
    return this.direction === 'outbound' ? 'Saliente' : 'Entrante';
  }

  get isSuccess(): boolean {
    return (
      this.statusCode !== null &&
      this.statusCode >= 200 &&
      this.statusCode <= 299 &&
      !this.error
    );
  }

  get statusClass(): string {
    return this.isSuccess ? 'text-bg-success' : 'text-bg-danger';
  }

  get serviceLabel(): string {
    const labels: { [key: string]: string } = {
      conekta: 'Conekta',
    };
    return labels[this.service.toLowerCase()] ?? this.service;
  }

  get requestHeadersParsed(): object | string {
    if (!this.requestHeaders) return {};
    try {
      return JSON.parse(this.requestHeaders);
    } catch {
      return this.requestHeaders;
    }
  }

  get requestBodyParsed(): object | string {
    if (!this.requestBody) return {};
    try {
      return JSON.parse(this.requestBody);
    } catch {
      return this.requestBody;
    }
  }

  get responseHeadersParsed(): object | string {
    if (!this.responseHeaders) return {};
    try {
      return JSON.parse(this.responseHeaders);
    } catch {
      return this.responseHeaders;
    }
  }

  get responseBodyParsed(): object | string {
    if (!this.responseBody) return {};
    try {
      return JSON.parse(this.responseBody);
    } catch {
      return this.responseBody;
    }
  }
}
